<template>
  <div class=" p-4 justify-center ">

    <div class=" w-full ">
      <div class="w-full flex ">
        <span class="bg-primary p-2 rounded w-1/2">Artikelnummer</span>
        <input class="p-2 w-1/2 border" v-model="value.articleNumber">
      </div>
      <div class="w-full flex mt-2 ">
        <span class="bg-primary p-2 rounded w-1/2">Neue Artikelnummer</span>
        <input class="p-2 w-1/2 border" v-model="newArticleNumber">
      </div>
    </div>
    <div class="flex mt-2">
      <button class="bg-trader-green w-full rounded p-2 hover:bg-trader-blue hover:text-white" @click="changeArticle">
        Ersetzen
      </button>
      <button class="bg-trader-green w-full rounded p-2 hover:bg-trader-blue hover:text-white" @click="closeModal">
        Abbrechen
      </button>
    </div>

  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus";
import ArticleOnMAgazine from "@/components/Dialogs/ArticleOnMAgazine.vue";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      newArticleNumber: '',
      marketIds: []
    }
  },
  methods: {
    closeModal() {
      eventBus.closeModal();
    },
    async changeArticle() {

      if (this.value.markets == 0) {
        this.marketIds.push(0);
      } else {
        this.value.markets.forEach((market) => {
          if (market.marketId !== 0) {
            this.marketIds.push(market.marketId);
          }
        });
      }


      apolloClient.mutate({
        mutation: gql`
            mutation changeArticle($magazineId: Int!,$pagePosition: Int!, $newArticleNumber: String!, $productId: Int!, $marketIds: [Int!]!) {
                changeArticle( magazineId: $magazineId, pagePosition: $pagePosition, newArticleNumber: $newArticleNumber, productId: $productId, marketIds: $marketIds) {
                    success
                }
            }
        `,
        variables: {
          magazineId: this.value.magazineId,
          pagePosition: this.value.pagePosition,
          newArticleNumber: this.newArticleNumber,
          productId: this.value.productId,
          marketIds: this.marketIds,
        }
      })
      try {
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.placeProductOnPageFromClipboard.code == "ARTICLE_IS_ON_MAGAZINE") {
          eventBus.openModal(ArticleOnMAgazine);
          eventBus.setData({
            articleNumber: this.newArticleNumber,
          });
        }

        if (this.value.onAccept) {
          this.value.onAccept();
          eventBus.closeModal();
        }


      } catch (e) {
        
        eventBus.closeModal();
      }
    },

  }
}


</script>

